const nurseRoutes = [
  {
    path: 'workplace',
    name: 'workplace',
    meta: {
      title: '工作站',
      requiresAuth: true,
      nav: false
    },
    component: resolve => require(['../views/page/page-workplace.vue'], resolve)
  },
  {
    path: 'nurse-appointment',
    name: 'nurse-appointment',
    meta: {
      title: '门诊预约',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
      // keepAlive: true
    },
    component: resolve => require(['../views/page/nurse/nurse-appointment.vue'], resolve)
  },
  {
    path: 'nurse-appointment-detail',
    name: 'nurse-appointment-detail',
    meta: {
      title: '门诊预约详情',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: {
          title: '门诊预约',
          path: '/default/nurse-appointment'
        }
      }
    },
    component: resolve => require(['../views/page/nurse/nurse-appointment-detail.vue'], resolve)
  },
  {
    path: 'nurse-guahao',
    name: 'nurse-guahao',
    meta: {
      title: '挂号取号',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/nurse/nurse-guahao.vue'], resolve)
  },
  {
    path: 'nurse-task',
    name: 'nurse-task',
    meta: {
      title: '任务',
      requiresAuth: true,
      nav: false
    },
    component: resolve => require(['../views/page/nurse/nurse-task.vue'], resolve)
  },
  {
    path: 'nurse-patient-manage',
    name: 'nurse-patient-manage',
    meta: {
      title: '病人管理',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/nurse/nurse-patient-manage.vue'], resolve)
  },
  {
    path: 'nurse-guahao-detail',
    name: 'nurse-guahao-detail',
    meta: {
      title: '预约挂号详情',
      requiresAuth: true,
      nav: false
    },
    component: resolve => require(['../views/page/nurse/nurse-guahao-detail.vue'], resolve)
  },
  {
    path: 'outpatient-list',
    name: 'outpatient-list',
    meta: {
      title: '患者列表',
      requiresAuth: true,
      nav: false
    },
    component: resolve => require(['../views/page/nurse/outpatient-list.vue'], resolve)
  },
  {
    path: 'outpatient-charge/:departmentId/:patientId/:outpatientId',
    name: 'outpatient-charge',
    meta: {
      title: '费用录入',
      requiresAuth: true,
      nav: false
    },
    component: resolve => require(['../views/page/nurse/outpatient-charge.vue'], resolve)
  }
]

export default nurseRoutes
